import { API_HOST } from '@/config';
import client, { ApiRoutes } from '@/store/client';
import { LookupValuesObjectArray } from './types';

const getLookupValues = (type: string) =>
  client.get<LookupValuesObjectArray>(`${API_HOST}/${ApiRoutes.Core}/${type}`);

export default { getLookupValues };
